import { IJackpotDisplay } from "./IJackpotDisplay";
import { IJackpotDisplayFactory } from "./IJackpotDisplayFactory";
import { IJackpotDisplayResponsive } from "./IJackpotDisplayPIXIAPPResponsive";
import { JackpotDisplay1screen } from "./JackpotDisplay1Screen";
import { JackpotDisplayCaliente } from "./JackpotDisplayCaliente";
import { JackpotDisplayDiamodPotPlayCity } from "./JackpotDisplayDiamodPotPlayCity";
import { JackpotDisplayDiamondPot } from "./JackpotDisplayDiamondPot";
import { JackpotDisplayDiamondPotPyramidJP4ShareJP3SinShared } from "./JackpotDisplayDiamondPotPyramidJP4ShareJP3SinShared";
import { JackpotDisplayDiamondPotPyramidPIXIAPPHorizontal } from "./JackpotDisplayDiamondPotPyramidPIXIAPPHorizontal";
import { JackpotDisplayDiamondPotPyramidShared } from "./JackpotDisplayDiamondPotPyramidShared";
import { JackpotDisplayDiamondPotPyramidSinShared } from "./JackpotDisplayDiamondPotPyramidSinShared";
import { JackpotDisplayDiamondPotRappidFrames } from "./JackpotDisplayDiamondPotRappidFrames";
import { JackpotDisplayDiamondPotRappidFramesSpine } from "./JackpotDisplayDiamondPotRappidFramesSpine";
import { JackpotDisplayDiamondPotResponsivePIXIAPP } from "./JackpotDisplayDiamondPotResponsivePIXIAPP";
import { JackpotDisplayDiamondPotResponsivePIXIAPPHorizontal } from "./JackpotDisplayDiamondPotResponsivePIXIAPPHorizontal";
import { JackpotDisplayDiamondPotStep } from "./JackpotDisplayDiamondPotStep";
import { JackpotDisplayDiamondPotStepRappidFrames } from "./JackpotDisplayDiamondPotStepRappidFrames";
import { JackpotDisplayDiamondPotStepRappidFramesSpine } from "./JackpotDisplayDiamondPotStepRappidFramesSpine";
import { JackpotDisplayDiamondPotStepShared } from "./JackpotDisplayDiamondPotStepShared";
import { JackpotDisplayDiamondPotStepSharedSpineV2 } from "./JackpotDisplayDiamondPotStepSharedSpineV2";
import { JackpotDisplayDiamondPotStepSinShared } from "./JackpotDisplayDiamondPotStepSinShared";
import { JackpotDisplayJubilee } from "./JackpotDisplayJubilee";
import { JackpotDisplayJubileeLink } from "./JackpotDisplayJubileeLink";
import { JackpotDisplayJubileeLink1Screen } from "./JackpotDisplayJubileeLink1Screen";
import { JackpotDisplayJubileeLink2S } from "./JackpotDisplayJubileeLink2";
import { JackpotDisplayJubileeLinkResponsivePIXIAPP } from "./JackpotDisplayJubileeLinkResponsivePIXIAPP";
import { JackpotDisplayJubileePIXIAPPHorizontal } from "./JackpotDisplayJubileePIXIAPPHorizontal";
import { JackpotDisplayOrtiz } from "./JackpotDisplayOrtiz";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotDisplayPaytable } from "./JackpotDisplayPaytable";
import { JackpotDisplayPlayCityLink } from "./JackpotDisplayPlayCityLink";
import { JackpotDisplayPlayCityLinkResponsivePIXIAPP } from "./JackpotDisplayPlayCityLinkResponsivePIXIAPP";
import { JackpotDisplayPlayCityPIXIAPPHorizontal } from "./JackpotDisplayPlayCityPIXIAPPHorizontal";
import { JackpotDisplayPrecSpin } from "./JackpotDisplayPrecSpin";
import { JackpotDisplayPyramid } from "./JackpotDisplayPyramid";
import { JackpotDisplayRainbowGirls } from "./JackpotDisplayRainbowGirls";
import { JackpotDisplayRainbowGirlsStep } from "./JackpotDisplayRainbowGirlsStep";
import { JackpotDisplayRapidLinkDiamondPotFire } from "./JackpotDisplayRapidLinkDiamondPotFire";
import { JackpotDisplayRapidLinkDiamondPotStep } from "./JackpotDisplayRapidLinkDiamondPotStep";
import { JackpotDisplayRapidLinkResponsivePIXIAPPHorizontal } from "./JackpotDisplayRapidLinkResponsivePIXIAPPHorizontal";
import { JackpotDisplayRappidDiamondPot } from "./JackpotDisplayRappidDiamondPot";
import { JackpotDisplayViventoLink2S } from "./JackpotDisplayViventoLink2";
import { Settings, JackpotDisplayType } from "./Settings";


export class JackpotDisplayFactory implements IJackpotDisplayFactory
{
    public CreateNewJackpotDisplay(params: JackpotDisplayParams): IJackpotDisplay
    {
        if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot){
            return new JackpotDisplayDiamondPot(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz)
        {
            return new JackpotDisplayOrtiz(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot)
        {
            return new  JackpotDisplayPyramid(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.PreciousSpin)
        {
            return new JackpotDisplayPrecSpin(params);
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep)
        {
            return new JackpotDisplayDiamondPotStep(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotJubilee)
        {
            return new JackpotDisplayJubilee(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotCaliente)
        {
            return new JackpotDisplayCaliente(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPlayCity)
        {
            return new JackpotDisplayDiamodPotPlayCity(params);
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.JubileeLink)
        {
            if (Settings.Screens == 3){
                return new JackpotDisplayJubileeLink(params);
            }
            else if (Settings.Screens == 2){
                return new JackpotDisplayJubileeLink2S(params);
            }
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.ViventoLink)
        {
            // if (Settings.Screens == 2){
                return new JackpotDisplayViventoLink2S(params);
            //}
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay)
        {
            return new JackpotDisplayPaytable(params);
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPot){
            return new JackpotDisplayRappidDiamondPot(params);
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPot2){
            return new JackpotDisplayRappidDiamondPot(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPotStep) {
            return new JackpotDisplayRapidLinkDiamondPotStep(params);
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPotFire){
            return new JackpotDisplayRapidLinkDiamondPotFire(params);
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.PlayCityLink){
            return new JackpotDisplayPlayCityLink(params);
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames){
            return new JackpotDisplayDiamondPotRappidFrames(params);
        }
        else if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepRappidFrames){
            return new JackpotDisplayDiamondPotStepRappidFrames(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPotStep2) {
            return new JackpotDisplayRapidLinkDiamondPotStep(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RainbowGirls) {
            if (Settings.Screens == 3) {
                return new JackpotDisplayRainbowGirls(params);
            } else if (Settings.Screens == 2) {
                return new JackpotDisplayRainbowGirlsStep(params);
            }
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared) {
            return new JackpotDisplayDiamondPotStepShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepSharedSpineV2) {
            return new JackpotDisplayDiamondPotStepSharedSpineV2(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepSinShared) {
            return new JackpotDisplayDiamondPotStepSinShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepRappidFramesSpine) {
            return new JackpotDisplayDiamondPotStepRappidFramesSpine(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFramesSpine) {
            return new JackpotDisplayDiamondPotRappidFramesSpine(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared) {
            return new JackpotDisplayDiamondPotPyramidShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared) {
            return new JackpotDisplayDiamondPotPyramidSinShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared) {
            return new JackpotDisplayDiamondPotPyramidJP4ShareJP3SinShared(params);
        }
        else 
        {
            throw "its not implemented"
        }
        return null;
    }

    public CreateNewJackpotDisplayResponsive(params: JackpotDisplayParams): IJackpotDisplayResponsive
    {
        if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotResponsivePIXI)
        {
            return new JackpotDisplayDiamondPotResponsivePIXIAPP(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.PlayCityLinkResponsivePIXI)
        {
            return new JackpotDisplayPlayCityLinkResponsivePIXIAPP(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JubileeLinkResponsivePIXI)
        {
            return new JackpotDisplayJubileeLinkResponsivePIXIAPP(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotResponsivePIXIHorizontal)
        {
            return new JackpotDisplayDiamondPotResponsivePIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinSharedResponsive)
        {
            return new JackpotDisplayDiamondPotPyramidPIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JubileeLinkResponsivePIXIAPPHorizontal)
        {
            return new JackpotDisplayJubileePIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal)
        {
            return new JackpotDisplayPlayCityPIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JackpotDisplayRapidLinkPIXIAPPHorizontal)
        {
            return new JackpotDisplayRapidLinkResponsivePIXIAPPHorizontal(params);
        }
        else
        {
            throw new Error("JackpotDisplayFactory: JackpotDisplayType not implemented");
        }
    }
/* This was made to create the JackpotDispaly for one screen and to work with jubile link*/
    public CreateNewJackpotDisplay1Screen(params: JackpotDisplayParams): IJackpotDisplay
    {
        if(Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot){
            return new  JackpotDisplay1screen(params);
        }else if(Settings.JackpotDisplayType == JackpotDisplayType.JubileeLink){
            return new JackpotDisplayJubileeLink1Screen(params); 
        }
        else{
            throw "It's not implemented"
        }
        return null;
    }
}